var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGooglePhotosIcon = function SvgGooglePhotosIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 59 59",
    xmlns: "http://www.w3.org/2000/svg",
    "jetway-hooks": "{}",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "jetway-hook-id": "D32A0C4D-4437-47B2-A852-7B39F943D3F1"
  }, /*#__PURE__*/React.createElement("g", {
    "jetway-hook-id": "647A0BE8-6A54-4FD3-92E7-3C0C54A07C51",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    "jetway-hook-id": "4B4991DA-B6A7-4A61-B064-B6BCDC859944"
  }, /*#__PURE__*/React.createElement("g", {
    "jetway-hook-id": "F7C64F54-09B8-4D6D-9454-F58219AA5601"
  }, /*#__PURE__*/React.createElement("g", {
    "jetway-hook-id": "45B02426-3A5F-49AF-8232-3C1F09D29D37"
  }, /*#__PURE__*/React.createElement("path", {
    "jetway-hook-id": "68097562-43CD-4175-BD0F-8131708A2434",
    d: "M-3-3h64v64H-3z"
  }), /*#__PURE__*/React.createElement("g", {
    "jetway-hook-id": "DD923623-943A-45E3-8DE8-A4A4B8A7C198",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.41c8.146 0 14.75 6.603 14.75 14.75v1.34H1.34C.6 29.5 0 28.9 0 28.16c0-8.147 6.604-14.75 14.75-14.75z",
    "jetway-hook-id": "B4287B30-9B3D-4F6B-9C01-2A7C2CA23D6F",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59 14.75c0 8.146-6.603 14.75-14.75 14.75H29.5V1.34C29.5.6 30.1 0 30.84 0c8.147 0 14.75 6.604 14.75 14.75z",
    "jetway-hook-id": "5872DD7E-5971-4393-9299-364708D669BC",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 45.59c-8.146 0-14.75-6.603-14.75-14.75V29.5h28.16c.74 0 1.34.6 1.34 1.34 0 8.147-6.604 14.75-14.75 14.75z",
    "jetway-hook-id": "184B2279-6FFE-4CA2-B961-54092B122EB8",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.41 44.25c0-8.146 6.603-14.75 14.75-14.75h1.34v28.16c0 .74-.6 1.34-1.34 1.34-8.147 0-14.75-6.604-14.75-14.75z",
    "jetway-hook-id": "2AD9C930-A41C-474E-9152-1E50FC2C457C",
    fill: "#34A853"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePhotosIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "847cd6cf7a307ebf55b28c015e7d3cf3.svg";